import React from 'react';
import { Box, Typography } from '@mui/material';
import { StyledGridContainer } from '../../Components/Styled';
import SelectBoxWithLabel from '../../Components/SelectBoxWithLable';
import { RemoveAddedFieldButton } from '../../Components/AddMoreOrRemoveButton';
import { handleValidateCodevalue } from '../../Utility/constant';
import { MONTHS, YEARLY_DAY_OPTIONS } from '../../Utility/workflowConfig';
import RunTimeField from '../../Components/RunTimeField';
import './workflow.css';
/**
 * A single row in the YEARLY trigger schedule configuration.
 * Renders Month dropdown, Date dropdown, optional RunTimeField (first row only),
 * and a remove button.
 */
const YearlyDateRow = ({
    idx,
    dateStr,
    isFirstRow,
    isViewMode,
    requiredError,
    handleYearlyRowDateChange,
    setYearlyDatesList,
    datesCount,
    internationalise,
    currentWfDetails,
    setCurrentWfDetail
}) => {
    const [m = "", d = ""] = (dateStr || "").split("-");

    return (
        <StyledGridContainer className="workflow-wrapper-container">
            <Box className="workflow-number-and-month">
                <Typography
                    className="workflow-number-label"
                >
                    {idx + 1}.
                </Typography>

                <SelectBoxWithLabel
                    select
                    disabled={isViewMode}
                    required
                    value={m}
                    label={handleValidateCodevalue(internationalise, "WF_EDIT_MONTH") || "Month"}
                    optionMenuItem={MONTHS}
                    handleOnChange={(e) =>
                        handleYearlyRowDateChange(idx, "month", e.target.value)
                    }
                    className="workflow-yearly-month"
                    error={m ? false : requiredError?.time}
                />
            </Box>

            <SelectBoxWithLabel
                select
                disabled={isViewMode}
                required
                value={d}
                label={handleValidateCodevalue(internationalise, "WF_EDIT_DATE") || "Date"}
                optionMenuItem={YEARLY_DAY_OPTIONS}
                handleOnChange={(e) =>
                    handleYearlyRowDateChange(idx, "date", e.target.value)
                }
                className="workflow-yearly-date"
                error={d ? false : requiredError?.time}
            />

            {isFirstRow && (
                <RunTimeField
                    value={currentWfDetails.structuredTime}
                    label={handleValidateCodevalue(
                        internationalise,
                        "WF_EDIT_TT_TIME_BASED_TITLE"
                    )}
                    disabled={isViewMode}
                    required
                    error={!currentWfDetails.structuredTime && requiredError.time}
                    onChange={(value) =>
                        setCurrentWfDetail(prev => ({
                            ...prev,
                            structuredTime: value
                        }))
                    }
                    textFieldProps={{
                        className: "workflow-yearly-time"
                    }}
                />
            )}

            <RemoveAddedFieldButton
                setRows={setYearlyDatesList}
                index={idx}
                visible={!isViewMode && datesCount > 1}
            />
        </StyledGridContainer>
    );
};

export default YearlyDateRow;
